import { render, staticRenderFns } from "./FluxoTicket.vue?vue&type=template&id=7a712360&scoped=true"
import script from "./FluxoTicket.vue?vue&type=script&lang=js"
export * from "./FluxoTicket.vue?vue&type=script&lang=js"
import style0 from "./FluxoTicket.vue?vue&type=style&index=0&id=7a712360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a712360",
  null
  
)

export default component.exports